import { Row } from "../styles";
import Input from "../../../../../components/inputField";
import { ESubInfo } from "../types";
import { StyledQuestion } from "../../styles";
import { FunctionalButton } from "../../../../../components/functionalButton";
import React from "react";

type PenaltiesInfoSectionProps = {
  esubData: ESubInfo;
  setESubData: (field: string, value: string) => void;
  isMobile: boolean;
  handleNext: () => void;
  panel: number;
  setPanel: (panel: number) => void;
  setIsLastPanel: (isLastPanel: boolean) => void;
  setPreviousStepPanel: (prevStepPanel: number) => void;
};

export const PenaltiesInfoSection = ({
  esubData,
  setESubData,
  isMobile,
  handleNext,
  panel,
  setPanel,
  setIsLastPanel,
  setPreviousStepPanel,
}: PenaltiesInfoSectionProps) => {
  // Helper function to format number with commas
  const formatNumberWithCommas = (value: string): string => {
    if (!value) return "";
    
    // Remove any existing commas and non-numeric characters except decimal point
    const cleanValue = value.replace(/[^\d.]/g, "");
    
    // Handle decimal numbers
    if (cleanValue.includes(".")) {
      const [wholePart, decimalPart] = cleanValue.split(".");
      const formattedWhole = wholePart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return `${formattedWhole}.${decimalPart}`;
    }
    
    // Handle whole numbers
    return cleanValue.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  // Helper function to remove commas for storage
  const removeCommas = (value: string): string => {
    return value.replace(/,/g, "");
  };

  return (
    <>
      <StyledQuestion isMobile={isMobile} width="650px">
        What Are the Penalty Details?
      </StyledQuestion>
      <Row>
        <Input
          label="Penalties / Damages ($ per day)"
          type="text"
          fontSize="18px"
          labelSize="12px"
          value={formatNumberWithCommas(esubData?.bond_details?.penalties_or_damages ?? "")}
          setValue={(e) => setESubData("bond_details.penalties_or_damages", removeCommas(e))}
          backgroundColor={undefined}
          color={undefined}
          placeholder={undefined}
          validateFunc={undefined}
          style={undefined}
          withoutMargin={undefined}
          marginTop={undefined}
          id={undefined}
          labelWeight={undefined}
          textAreaHeight={undefined}
          borderColor={undefined}
          autoComplete={undefined}
          noCheckIcon={undefined}
          cancelIcon={undefined}
          noErrorBorder={undefined}
          ref={undefined}
          hasError={undefined}
          inputId={undefined}
          disabled={undefined}
          width={undefined}
          paddingRight={undefined}
          paddingLeft={undefined}
          onBlur={undefined}
          showError={undefined}
          readOnly={undefined}
          marginRight={undefined}
        />
        <Input
          label="Other"
          type="text"
          fontSize="18px"
          labelSize="12px"
          value={esubData?.bond_details?.other_penalties ?? ""}
          setValue={(e) => setESubData("bond_details.other_penalties", e)}
          backgroundColor={undefined}
          color={undefined}
          placeholder={undefined}
          validateFunc={undefined}
          style={undefined}
          withoutMargin={undefined}
          marginTop={undefined}
          id={undefined}
          labelWeight={undefined}
          textAreaHeight={undefined}
          borderColor={undefined}
          autoComplete={undefined}
          noCheckIcon={undefined}
          cancelIcon={undefined}
          noErrorBorder={undefined}
          ref={undefined}
          hasError={undefined}
          inputId={undefined}
          disabled={undefined}
          width={undefined}
          paddingRight={undefined}
          paddingLeft={undefined}
          onBlur={undefined}
          showError={undefined}
          readOnly={undefined}
          marginRight={undefined}
        />
      </Row>
      <FunctionalButton
        buttonTitle="Next"
        handleButton={() => {
          handleNext();
          setPanel(5);
        }}
        width={undefined}
        height={undefined}
        isReversedColor={undefined}
        marginRight={undefined}
        marginLeft={undefined}
        marginTop={"40px"}
        marginBottom={undefined}
        fontSize={undefined}
        disabled={undefined}
        icon={undefined}
        hasBoxShadow={undefined}
        frontIcon={undefined}
        weight={undefined}
        borderColor={undefined}
        selected={undefined}
      />
    </>
  );
};
